module.exports = __webpack_public_path__ + "static/fonts/Fact-ExtraLight.7dadfdc.woff";